import { Box, Inline, xcss } from '@atlaskit/primitives';
import { FieldValueTypes } from '@databases/redux/connections/slice';
import React, { FunctionComponent } from 'react';

import EllipsisOverflow from '../common/EllipsisOverflow';

interface PageStatusProps {
  status: Extract<FieldValueTypes, { type: 'pageStatus' }>['value'];
}

const DotStyles = xcss({
  borderRadius: '12px',
  minWidth: '12px',
  height: '12px',
  marginRight: 'space.075',
});

const ContainerStyles = xcss({
  display: 'inline-flex',
  backgroundColor: 'color.background.neutral',
  color: 'color.text',
  borderRadius: '3px',
  paddingBlock: 'space.025',
  paddingInline: 'space.100',
  whiteSpace: 'nowrap',
  maxWidth: 'calc(100% - 16px)',
});

const PageStatus: FunctionComponent<PageStatusProps> = ({ status }) => {
  return (
    <Inline as="div" alignBlock="center" xcss={ContainerStyles}>
      <Box
        xcss={[
          xcss({
            // @ts-ignore - xcss doesn't support custom color values
            backgroundColor: status.color,
          }),
          DotStyles,
        ]}
      />
      <EllipsisOverflow>{status.text}</EllipsisOverflow>
    </Inline>
  );
};

export default PageStatus;
